// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-window.classic.js, новая — rack-window.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-window.classic';
import * as cp from './rack-window.cp';

export const RackWindow = isCp ? cp.RackWindow : classic.RackWindow;
